<template>
    <div id="footer">
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-4 col-lg-2 text-center text-md-left">
                    <router-link :to="{ name: 'Home' }" id="footer-logo" class="mb-4 mx-auto mx-md-0"></router-link>
                    <div class="address mb-4" v-if="isOptionsContentLoaded" v-html="footerAddress"></div>
                    <!-- /.address -->

                    <!-- Social -->
                    <ul class="nav justify-content-center justify-content-md-start" v-if="isOptionsContentLoaded">
                        <li class="nav-item" v-for="(social, index) in socials" :key="index">
                          <a :href="social.url" :class="['nav-icon', social.social_network]" target="_blank">{{ social.social_network }}</a>
                        </li>
                    </ul>
                    <!-- /.nav Social -->
                </div>
                <div class="col d-none d-md-block">
                    <div class="row">
                      <div class="col" v-if="isMenusLoaded">
                        <ul class="nav">
                          <li :class="['nav-item', menu.child_items ? 'has-child' : '']" v-for="menu in menus" :key="menu.ID">
                            <a href="#" class="nav-link" v-if="menu.ID && !menu.route_name">{{ menu.title }}</a>
                            <router-link :to="{ name: menu.route_name ? menu.route_name : 'Page', params: { slug: menu.slug ? menu.slug : menu.post_name } }" :target="menu.target" class="nav-link" v-if="menu.ID && menu.route_name">{{ menu.title }}</router-link>
                            <ul class="nav sub-nav flex-column" v-if="menu.child_items">
                              <li class="nav-item" v-for="submenu in menu.child_items" :key="submenu.ID">
                                <a :href="submenu.url" class="nav-link" v-if="!submenu.route_name">{{ submenu.title }}</a>
                                <router-link :to="{ name: submenu.route_name, params: { category: menu.post_name, slug: submenu.slug } }" :target="submenu.target" class="nav-link" v-if="submenu.route_name">{{ submenu.title }}</router-link>
                              </li>
                            </ul>
                            <ul class="nav flex-column" v-if="isArray(menu)">
                              <li class="nav-item" v-for="indmenu in menu" :key="indmenu.ID">
                                <a href="#" class="nav-link" v-if="!indmenu.route_name">{{ indmenu.title }}</a>
                                <router-link :to="{ name: indmenu.route_name ? indmenu.route_name : 'Page', params: { slug: indmenu.slug ? indmenu.slug : indmenu.post_name } }" :target="indmenu.target" class="nav-link" v-if="indmenu.route_name">{{ indmenu.title }}</router-link>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </div>

                        <!-- Invisible -->
                        <div class="col-1"></div>
                    </div>
                    <!-- /.row -->
                </div>
                <div class="col d-none d-lg-block">
                    <div id="footer-about" v-if="isOptionsContentLoaded" v-html="footerContent"></div>
                    <!-- /#footer-about -->
                </div>
            </div>
            <!-- /.row -->

            <div class="row">
                <div class="col-12">
                    <div class="copyright">
                        <p class="text-center text-md-left">Copyright &copy; {{ year }} Xilda Inc. All rights reserved.</p>
                    </div>
                </div>
            </div>
            <!-- /.row -->
        </div>
        <!-- /.container -->
    </div>
    <!-- /#footer -->
</template>

<script>
import '@/assets/sass/footer.sass'
import axios from 'axios'
import dayjs from 'dayjs'
export default {
  name: 'Footer',
  props: [
    'footerAddress', 'footerContent', 'socials', 'isOptionsContentLoaded'
  ],
  data () {
    return {
      api_path: process.env.VUE_APP_API_PATH,
      year: dayjs().format('YYYY'),
      menus: [],
      isMenusLoaded: false
    }
  },
  created () {
    this.getMenus()
  },
  methods: {
    getMenus () {
      const vm = this
      axios.get(`${this.api_path}wp-json/menus/v1/menus/main-navigation`)
        .then(res => {
          if (res.data) {
            const menus = res.data.items
            const menu = []
            const otherMenus = []
            let i = 0
            for (const index in menus) {
              if (menus[index].child_items) {
                menu[i] = menus[index]
                i++
              } else {
                otherMenus.push(menus[index])
              }
            }
            menu[i] = otherMenus
            vm.menus = menu
            vm.isMenusLoaded = true
          }
        })
    },
    isArray (item) {
      return item.constructor === Array
    }
  }
}
</script>
